import script from "./LayoutView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutView.vue?vue&type=script&setup=true&lang=ts"

import "./LayoutView.vue?vue&type=style&index=0&id=4f17b24b&lang=scss"

const __exports__ = script;

export default __exports__